import Vue from 'vue'
import axios from '@/plugins/axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default Vue
